import {Location} from '@angular/common';
import {HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class QueryParamsService {

  constructor(
    private location: Location
  ) { }

  /**
   * Añade o reemplaza el valor de un query Params para la búsqueda y paginación
   */
  setQueryString(
    url: string, queryParams: HttpParams, paramName: string, paramValue: string | number | boolean, replaceUrl: boolean = true
  ): HttpParams {
    if (!queryParams?.has(paramName)) {
      queryParams = queryParams.append(paramName, paramValue);
    } else {
      queryParams = queryParams.set(paramName, paramValue);
    }
    if (replaceUrl) {
      this.location?.replaceState(url.split('?')[0], queryParams.toString());
    }
    return queryParams;
  }

  /**
   * Borra el query param para la búsqueda y paginación
   */
  deleteQueryString(url: string, queryParams: HttpParams, paramName: string, replaceUrl: boolean = true): HttpParams {
    queryParams = queryParams.delete(paramName);
    if (replaceUrl) {
      this.location?.replaceState(url.split('?')[0], queryParams.toString());
    }
    return queryParams;
  }
}
